import React from "react";

const Spinner = () => {
    const defaultCss = 'spinner';
    return <div className={defaultCss} />;
};

export { Spinner }